export default __webpack_public_path__ + "static/media/park.56dec270.svg";